import { forwardRef } from "react";

const EyeHiddenIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2764_103822)">
        <path
          d="M14.7557 14.7558L3.24341 3.24387L3.24095 3.24106C3.17863 3.17924 3.10473 3.1303 3.0235 3.09704C2.94226 3.06378 2.85526 3.04684 2.76748 3.0472C2.67969 3.04756 2.59284 3.06521 2.51187 3.09913C2.43091 3.13306 2.35742 3.1826 2.2956 3.24492C2.23378 3.30725 2.18485 3.38114 2.15158 3.46238C2.11832 3.54362 2.10139 3.63062 2.10175 3.7184C2.10247 3.89569 2.17359 4.06543 2.29947 4.19028L3.3074 5.1982C2.08505 6.03536 1.03292 7.09716 0.206969 8.32711C0.0720918 8.52625 0 8.76124 0 9.00176C0 9.24227 0.0720918 9.47727 0.206969 9.67641C2.31529 12.7969 5.65759 14.625 8.9999 14.6021C10.0825 14.6061 11.1579 14.4258 12.1801 14.0692L13.8117 15.7008C13.9374 15.8224 14.1059 15.8899 14.2808 15.8887C14.4557 15.8875 14.6232 15.8178 14.7473 15.6944C14.8713 15.5711 14.942 15.404 14.9442 15.229C14.9463 15.0541 14.8798 14.8853 14.7588 14.7589L14.7557 14.7558ZM8.9999 12.7877C8.36666 12.7875 7.74358 12.6286 7.1876 12.3255C6.63162 12.0224 6.16046 11.5848 5.81719 11.0526C5.47393 10.5205 5.26949 9.91084 5.22257 9.27935C5.17565 8.64785 5.28775 8.01467 5.54861 7.43766L6.60154 8.49059C6.51673 8.89024 6.53312 9.30475 6.64922 9.69646C6.76532 10.0882 6.97745 10.4447 7.26634 10.7336C7.55523 11.0225 7.91173 11.2346 8.30344 11.3507C8.69515 11.4668 9.10966 11.4832 9.50931 11.3984L10.5622 12.4513C10.0715 12.6738 9.53874 12.7885 8.9999 12.7877Z"
          fill="#ADB5BD"
        />
        <path
          d="M17.7935 8.32537C15.6852 5.20314 12.3429 3.37502 9.00055 3.39787C7.91792 3.39395 6.84251 3.57418 5.82031 3.93084L7.4375 5.54803C8.13925 5.23045 8.92112 5.13429 9.6789 5.27235C10.4367 5.41042 11.1344 5.77615 11.6791 6.3208C12.2237 6.86546 12.5894 7.56317 12.7275 8.32096C12.8656 9.07875 12.7694 9.86062 12.4518 10.5624L14.6927 12.8032C15.9152 11.9662 16.9675 10.9044 17.7935 9.67432C17.9283 9.47521 18.0003 9.24029 18.0003 8.99984C18.0003 8.7594 17.9283 8.52447 17.7935 8.32537Z"
          fill="#ADB5BD"
        />
        <path
          d="M8.99965 6.54823C8.82845 6.54825 8.65771 6.56616 8.49023 6.60167L11.398 9.50909C11.4738 9.15187 11.4689 8.78222 11.3836 8.42715C11.2982 8.07208 11.1347 7.74056 10.9048 7.45679C10.675 7.17303 10.3846 6.94419 10.055 6.787C9.7254 6.62981 9.36483 6.54823 8.99965 6.54823Z"
          fill="#ADB5BD"
        />
      </g>
      <defs>
        <clipPath id="clip0_2764_103822">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
);

EyeHiddenIcon.displayName = "EyeHiddenIcon";

export default EyeHiddenIcon;
